import { render, staticRenderFns } from "./AddNewLesson.vue?vue&type=template&id=58c59074&scoped=true&"
import script from "./AddNewLesson.vue?vue&type=script&lang=js&"
export * from "./AddNewLesson.vue?vue&type=script&lang=js&"
import style0 from "./AddNewLesson.vue?vue&type=style&index=0&id=58c59074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c59074",
  null
  
)

export default component.exports